<template>
<div class="img">
  <img :src="imageUrl" alt srcset width="180" />
</div>

</template>
<script>
export default {
  props: ["message"],
  data() {
    return {
      imageUrl: null
    };
  },
  created() {
    this.imageUrl = this.message.message.message.attachment.payload.url;
  }
};
</script>
<style>
  
</style>>